// This file is auto-generated by @hey-api/openapi-ts

export const TariffCoreTypesEnum = { ZONE: 'ZONE', RELATIONAL: 'RELATIONAL' } as const;

export type TariffCoreTypesEnum = typeof TariffCoreTypesEnum[keyof typeof TariffCoreTypesEnum];
